import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import LayoutComponent from "../components/layout";
import { areEqual } from "../libs/utils";
import { ReducersType } from "../store";
import { MessengerThemeType } from "../store/messenger/types";

type Props = {
  children: ReactNode;
};

const Layout: FC<Props> = (props) => {
  const appTheme = useSelector<ReducersType, MessengerThemeType>((state) => state.messenger.messengerTheme, areEqual);

  return <LayoutComponent appTheme={appTheme}>{props.children}</LayoutComponent>;
};

export default Layout;
